"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Facebook = function Facebook(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30"
  }, props), (0, _core.jsx)("path", {
    d: "M14.415 15.78H9.892V30H3.188V15.78H0v-5.568h3.188V6.61C3.188 4.034 4.44 0 9.952 0l4.966.02v5.404h-3.603c-.592 0-1.423.289-1.423 1.518v3.276H15l-.585 5.562z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var _default = Facebook;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Facebook, "Facebook", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/assets/Facebook.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/assets/Facebook.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9Gb290ZXIvYXNzZXRzL0ZhY2Vib29rLnRzeCJdLCJuYW1lcyI6WyJGYWNlYm9vayIsInByb3BzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsUUFBMEQsR0FBRyxTQUE3REEsUUFBNkQsQ0FBQ0MsS0FBRCxFQUFXO0FBQzVFLFNBQ0U7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9EQSxLQUFwRCxHQUNFO0FBQ0UsSUFBQSxDQUFDLEVBQUMsNkpBREo7QUFFRSxJQUFBLElBQUksRUFBQyxjQUZQO0FBR0UsSUFBQSxRQUFRLEVBQUM7QUFIWCxJQURGLENBREY7QUFTRCxDQVZEOztlQVllRCxROzs7Ozs7Ozs7Ozs7MEJBWlRBLFEiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IEZhY2Vib29rOiBGdW5jdGlvbkNvbXBvbmVudDxSZWFjdC5TVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMpID0+IHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnIHdpZHRoPXsxNX0gaGVpZ2h0PXszMH0gdmlld0JveD1cIjAgMCAxNSAzMFwiIHsuLi5wcm9wc30+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE0LjQxNSAxNS43OEg5Ljg5MlYzMEgzLjE4OFYxNS43OEgwdi01LjU2OGgzLjE4OFY2LjYxQzMuMTg4IDQuMDM0IDQuNDQgMCA5Ljk1MiAwbDQuOTY2LjAydjUuNDA0aC0zLjYwM2MtLjU5MiAwLTEuNDIzLjI4OS0xLjQyMyAxLjUxOHYzLjI3NkgxNWwtLjU4NSA1LjU2MnpcIlxuICAgICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgICAgZmlsbFJ1bGU9XCJldmVub2RkXCJcbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBGYWNlYm9vaztcbiJdfQ==